module.exports = __webpack_public_path__ + "static/img/icon_my_tx.41cff8a.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/assets/icon_my_tx.jpg
// module id = xXll
// module chunks = 2